import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-verification-tips-panel',
    templateUrl: './verification-tips-panel.component.html',
    styleUrls: ['./verification-tips-panel.component.scss'],
    standalone: false
})
export class VerificationTipsPanelComponent {
  @Output() onResendConfirmationCode: EventEmitter<any> = new EventEmitter();

  onClick() {
    this.onResendConfirmationCode.emit();
  }
}
